/* eslint-disable prettier/prettier */
import { CountryCode } from "../enums/country-code.enum";

export const cultures = {
    cultureData: [
        { currentCulture: "en-US", code: "USD", dateFormat: "MM/dd/y" },
        { currentCulture: "fr-FR", code: "EUR", dateFormat: "dd/MM/y" },
        { currentCulture: "en-GB", code: "GBP", dateFormat: "dd/MM/y" },
        { currentCulture: "en-CA", code: "CAD", dateFormat: "y/MM/dd" },
    ],
    defaultCultureData: {
        currentCulture: "en-US",
        code: "USD",
        formatOptions: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};

export const postalCodesMap = new Map<CountryCode, RegExp>([
    [CountryCode.US, /^([0-9]{5})(?:-([0-9]{4}))?$/],
    [CountryCode.CA, /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i],
    [CountryCode.FR, /^\d{2}[ ]?\d{3}$/],
    [CountryCode.GB, /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i],
]);
